import { useTranslation } from 'react-i18next';

import ArrowRightLine from '@/assets/icons/arrow_right_line.svg?component';
import { CardHeader } from '@/components/atoms/Card';
import { type IconComponent, SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';
import TitleIcon from '@/components/atoms/TitleIcon/TitleIcon';

import styles from './HelpPageFAQ.module.scss';

const KNOWLEDGE_BASE_URL = 'https://knowledge.optoscale.no';
const KNOWLEDGE_BASE_LABEL = 'knowledge.optoscale.no';

interface HelpPageFAQProps {
    headerText: string;
    headerIcon?: IconComponent;
    description: string;
}

function HelpPageFAQ({ headerText, headerIcon, description }: HelpPageFAQProps) {
    const { t } = useTranslation();

    return (
        <div className={styles.faqSection} data-type="helpPageFAQSection">
            <CardHeader
                title={headerText}
                level="h2"
                size="card"
                icon={headerIcon && <TitleIcon icon={headerIcon} />}
            />
            <p>{description}</p>
            <a
                className={styles.knowledgeBaseLink}
                href={KNOWLEDGE_BASE_URL}
                target="_blank"
                rel="noreferrer">
                <span className={styles.linkContent}>
                    <span className={styles.linkTitle}>{t('helpPageFAQ.knowledgeBaseTitle')}</span>
                    <span className={styles.linkUrl}>{KNOWLEDGE_BASE_LABEL}</span>
                </span>
                <SvgIcon
                    icon={ArrowRightLine}
                    size="custom"
                    customSize={20}
                    color="var(--color-success-fill)"
                />
            </a>
        </div>
    );
}

export default HelpPageFAQ;
